// propertyInputs.js — category_id controls visibility (no field_keys in blocks needed)
// Blocks just declare block_type — inputs filter themselves by category_id

const propertyInputs = {

  // ── Information Block fields ──────────────────────────────────
  property_name: {
    id: 1, field: "property_name", label: "Property Name",
    type: "text", placeholder: "Enter property name",
    is_show: true, block_key: "information",
    type_id: [9,10,11,12], category_id: [22,23,24,25,26,27,28,29,30,31.32,33,34,35,36,37,38,39,40,41,42,43],
    category_required: [],
    other_show: [], other_required: [],
    landtype: false, dropdown: false,
  },

  bhk: {
    id: 6, field: "bhk", label: "BHK Type",
    type: "select", placeholder: "Select BHK type",
    is_show: true, block_key: "information",
    type_id: [9,10], category_id: [22,23,24,25,28,29,37],
    category_required: [22,23,24,25,28,29,37],
    other_show: [], other_required: [],
    landtype: false, dropdown: true, dropdown_id: 5,
  },

    total_floors: {
    id: 8, field: "total_floors", label: "Total Floors",
    type: "select", placeholder: "Select total floors",
    is_show: true, block_key: "information",
    type_id: [9,10,11], category_id: [22,23,24,25,30,31,32,33,36,37,40],
    category_required: [],
    other_show: [], other_required: [],
    landtype: false, dropdown: true, dropdown_id: 7,
  },

  property_floor_no: {
    id: 7, field: "property_floor_no", label: "Floor Number",
    type: "select", placeholder: "Select floor",
    is_show: true, block_key: "information",
    type_id: [9,10,11], category_id: [22,25,28,29,30,31,32,33,36,37,40],
    category_required: [22,25,28,29,30,31,32,33,36,37,],
    other_show: [], other_required: [],
    landtype: false, dropdown: true, dropdown_id: 6,
  },
  total_washroom: {
    id: 7, field: "total_washroom", label: "Total Washroom",
    type: "number", placeholder: "Enter Total Washroom",
    is_show: true, block_key: "information",
    type_id: [10,11], category_id: [30,31,32,33,38,40,41],
    category_required: [],
    other_show: [], other_required: [],
    landtype: false, dropdown: false,
  },
  car_parking: {
    id: 7, field: "car_parking", label: "Car Parking",
    type: "number", placeholder: "Enter Car Parking",
    is_show: true, block_key: "information",
    type_id: [9,10,11], category_id: [22,23,24,25,28,29,30,31,32,33,37,38,40,41],
    category_required: [22,23,24,25,28,29],
    other_show: [], other_required: [],
    landtype: false, dropdown: false,
  },
  bike_parking: {
    id: 7, field: "bike_parking", label: "Bike Parking",
    type: "number", placeholder: "Enter Bike Parking",
    is_show: true, block_key: "information",
    type_id: [9,10,11], category_id: [22,23,24,25,28,29,30,31,32,33,37,38,40,41,],
    category_required: [22,23,24,25,28,29],
    other_show: [], other_required: [],
    landtype: false, dropdown: false,
  },
  
  direction: {
    id: 10, field: "direction", label: "Property Direction",
    type: "select", placeholder: "Select direction",
    is_show: true, block_key: "information",
    type_id: [9,10], category_id: [22,23,24,25,26,28,29,34],
    category_required: [22,23,24,25,26,28,29,34],
    other_show: [], other_required: [],
    landtype: false, dropdown: true, dropdown_id: 1,
  },

  gated_community: {
    id: 9, field: "gated_community", label: "Gated Community",
    type: "select", placeholder: "Select",
    is_show: true, block_key: "information",
    type_id: [9], category_id: [23,24,26],
    category_required: [23,24,26],
    other_show: [], other_required: [],
    landtype: false, dropdown: true, dropdown_id: 2,
  },
  is_corner: {
    id: 9, field: "is_corner", label: "Is This a Corner Plot",
    type: "select", placeholder: "Select",
    is_show: true, block_key: "information",
    type_id: [9,10], category_id: [26,34],
    category_required: [26,34],
    other_show: [], other_required: [],
    landtype: false, dropdown: true, dropdown_id: 2,
  },
  boundary_fencing: {
    id: 9, field: "boundary_fencing", label: "Boundary fencing/WALL",
    type: "select", placeholder: "Select",
    is_show: true, block_key: "information",
    type_id: [12], category_id: [42,43],
    category_required: [26,34],
    other_show: [], other_required: [],
    landtype: false, dropdown: true, dropdown_id: 2,
  },
property_availability: {
    id: 13, field: "property_availability", label: "Availability Status",
    type: "select", placeholder: "Select status",
    is_show: true, block_key: "information",
    type_id: [9,10,11], category_id: [22,23,24,25,28,29,30,31,32,33,37,38,40,41],
    category_required: [22,23,24,25,28,29,30,31,32,33,37,38,40,41],
    other_show: [], other_required: [],
    landtype: false, dropdown: true, dropdown_id: 8,
  },

  furnishing: {
    id: 11, field: "furnishing", label: "Furnishing Status",
    type: "select", placeholder: "Select status",
    is_show: true, block_key: "information",
    type_id: [9,10,11], category_id: [22,23,24,25,28,29,30,31,32,33,37,38,40,41],
    category_required: [22,23,24,25,28,29,30,31,32,33,37,38,40,41],
    other_show: [], other_required: [],
    landtype: false, dropdown: true, dropdown_id: 3,
  },

  property_age: {
    id: 12, field: "property_age", label: "Property Age",
    type: "select", placeholder: "Select age",
    is_show: true, block_key: "information",
    type_id: [9,10,11], category_id: [22,23,24,25,28,29,30,31,32,33,37,38,40,41],
    category_required: [22,23,24,25,28,29,30,31,32,33,37,38,40,41],
    other_show: [], other_required: [],
    landtype: false, dropdown: true, dropdown_id: 4,
  },

  description: {
    id: 14, field: "description", label: "Description",
    type: "textarea", placeholder: "Enter property description",
    is_show: true, block_key: "information",
    type_id: [9,10,11,12], category_id: [22,23,24,25,26,27,28,29,30,31.32,33,34,35,36,37,38,39,40,41,42,43],
    category_required: [],
    other_show: [], other_required: [],
    landtype: false, dropdown: false,
  },


  // ── Land Area fields ───────────────────────────────────────────
  price: {
    id: 2, field: "price", label: "Price (₹)",
    type: "number", placeholder: "Enter total price",
    is_show: true, block_key: "land_area",
    type_id: [9,10,11,12], category_id: [22,23,24,25,26,27,28,29,30,31,32,33,34,35,36,37,38,39,40,41,42,43],
    category_required: [22,23,24,25,26,27,28,29,30,31.32,33,34,35,36,37,38,39,40,41,42,43],
    other_show: [], other_required: [],
    landtype: false, dropdown: false, is_price_field: true,
  },

  buildup_area: {
    id: 3, field: "buildup_area", label: "Built-Up Area",
    type: "number", placeholder: "Enter built-up area",
    is_show: true, block_key: "land_area",
    type_id: [9,10,11], category_id: [22,23,24,25,28,29,30,31,32,33,36,37,38,40,41],
    category_required: [22,23,24,25,28,29,30,31,32,33,36,37,38,40,41],
    other_show: [], other_required: [],
    landtype: true, is_land_primary: [22,23,24,25,28,29,30,31,32,33,36,37,38,40,41], dropdown: false ,landtype_ids: [1,2,3],
  },
 carpet_area: {
    id: 5, field: "carpet_area", label: "Carpet Area",
    type: "number", placeholder: "Enter carpet area",
    is_show: true, block_key: "land_area",
    type_id: [9,10,11], category_id: [22,23,24,25,28,29,30,31,32,33,36,37,38,40,41],
    category_required: [],
    other_show: [], other_required: [],
    landtype: true, is_land_primary: [], dropdown: false,landtype_ids: [1,2,3],
  },
  land_area1: {
    id: 4, field: "land_area1", label: "Land Area",
    type: "number", placeholder: "Enter Land area",
    is_show: true, block_key: "land_area",
    type_id: [9,10,11], category_id: [23,24,26,27,31,32,33,34,35,36,37,38,39,40,41,42,43],
    category_required: [26,27,34,35,39,42,43],
    other_show: [], other_required: [],
    landtype: true, is_land_primary: [26,27,34,35,39,42,43], dropdown: false,landtype_ids: [1,2,3,4,5,6],
  },

  // ── Image fields ───────────────────────────────────────────────
  thumbnail: {
    id: 20, field: "thumbnail", label: "Thumbnail Image",
    type: "file", placeholder: "",
    is_show: true, block_key: "images",
    type_id: [], category_id: [],
    category_required: [1,2,3,4,5,6],
    other_show: [], other_required: [1,2],
    multi_upload: false, accept: "image/*",
    landtype: false, dropdown: false,
  },

  slider: {
    id: 21, field: "slider", label: "Slider Images",
    type: "file", placeholder: "",
    is_show: true, block_key: "images",
    type_id: [], category_id: [],
    category_required: [],
    other_show: [], other_required: [],
    multi_upload: true, accept: "image/*",
    landtype: false, dropdown: false,
  },

  // ── SEO fields ─────────────────────────────────────────────────
  seo_title: {
    id: 31, field: "seo_title", label: "SEO Title",
    type: "text", placeholder: "Enter SEO title",
    is_show: true, block_key: "seo",
    type_id: [], category_id: [],
    category_required: [], other_show: [], other_required: [],
    landtype: false, dropdown: false,
  },

  seo_description: {
    id: 32, field: "seo_description", label: "SEO Meta Description",
    type: "textarea", placeholder: "Enter SEO description",
    is_show: true, block_key: "seo",
    type_id: [], category_id: [],
    category_required: [], other_show: [], other_required: [],
    landtype: false, dropdown: false,
  },
};

export default propertyInputs;